import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngry } from "@fortawesome/free-solid-svg-icons";

const IconAngry = ({ ...props }) => {
  return <FontAwesomeIcon icon={faAngry} color="#6B98AD" {...props} />;
};

export default IconAngry;
